import { useState, useEffect } from "react";
import "./Contant.css";
import Sightseeing from "./Siteseeing";
import Navbar from "./Navbar";
import Hero from "./Hero";
import { AboutIntro, StatsBand, HowItWorks, Gallery, FAQ, CtaBand, FeaturedStays, ReviewsLive } from "./Sections";
import { LivePackages, LiveRooms, LiveVehicles } from "./LiveCatalog";
import { connectRealtime, onRealtime, closeRealtime } from "./realtime";
import OfferCountdown from "./OfferCountdown";
import HomeAds from "./HomeAds";
import Payment from "./Payment";
import TermsModal from "./TermsModal";
import BookingLeadModal from "./BookingLeadModal";

const PRICING_API = "https://feitevmd2k.execute-api.ap-south-1.amazonaws.com/prod/public/web-pricing";

const packages = [
  {
    type: "Private Group (PP)",
    image:
      "https://img.freepik.com/premium-photo/group-friends-hike-trail-up-mountain-camp-nature-landscape-extreme-adventure-holiday-team-people-explore-earth-together-hiking-trip-mountains-hill-while-vacation_590464-86160.jpg?w=2000",
    prices: {
      "2D 1N": { original: "₹2,999", discounted: "₹2,499" },
      "3D 2N": { original: "₹4,499", discounted: "₹3,999" },
      "4D 3N": { original: "₹5,999", discounted: "₹5,499" },
    },
    inclusions: [
      "Private cab",
      "Ooty Pickup & Drop",
      "Other location pickup available on request (Extra charges may apply)",
      "Hill view stay CI: 12pm CO: 10am",
      "Breakfast & Dinner",
      "Sightseeing",
      "Campfire",
    ],
    exclusions: ["Lunch", "Entry tickets", "Personal expenses"],
    addons: ["Toy Train Ride", "BBQ / Grill", "Lunch"],
    Terms: [
      "Prices are per person for a minimum of 10 to 14 people",
      "Prices may vary during peak season and holidays",
      "30% advance payment required to confirm booking (*non-refundable)",
      "Final payment due before Check In",
      "Cancellation made less than 3 days before travel may attract 100% charge of the package cost",
      "Custom requests subject to availability",
      "Itinerary changes may affect pricing",
      "Special requests (e.g. dietary, accessibility) must be communicated in advance",
      "Bookings subject to terms of service",
      "Travel insurance recommended",
      "OotyGo not liable for unforeseen circumstances (e.g. weather, strikes)",
      "All bookings subject to availability at time of payment",
      "Prices and inclusions/exclusions subject to change without notice",
      "OotyGo reserves the right to refuse service to anyone",
      "By booking, you agree to OotyGo's full terms and conditions",
      "Travelers must comply with local laws and regulations",
      "OotyGo is not responsible for personal belongings",
      "Health and safety protocols must be followed",
      "Travelers are responsible for their own travel documents (e.g. ID, permits)",
      "OotyGo reserves the right to modify or cancel bookings in case of emergencies",
      "All disputes subject to jurisdiction of Nilgiris courts",
      "OotyGo is committed to sustainable and responsible tourism",
      "By booking, you agree to respect local culture and environment",
      "OotyGo may use photos/videos taken during the trip for promotional purposes unless otherwise requested",
      "For any queries or special requests, please contact us at least 7 days before travel",
      "OotyGo's decision is final in case of any disputes or issues",
      "Additional terms may apply based on specific selections or requests",
    ],
  },
  {
    type: "Couples",
    image:
      "https://tse2.mm.bing.net/th/id/OIP.hGe2eH6Q01I7JOVjqK7XvAHaEo?cb=12&rs=1&pid=ImgDetMain&o=7&rm=3",
    prices: {
      "2D 1N": { original: "₹15,999", discounted: "₹12,999" },
      "3D 2N": { original: "₹20,999", discounted: "₹19,999" },
      "4D 3N": { original: "₹29,999", discounted: "₹27,999" },
    },
    inclusions: [
      "Private cab",
      "Ooty Pickup & Drop",
      "Other location pickup available on request (Extra charges may apply)",
      "Hill view stay CI: 12pm CO: 10am",
      "Breakfast & Dinner",
      "Sightseeing",
      "Campfire",
    ],
    exclusions: ["Lunch", "Entry tickets", "Personal expenses"],
    addons: [
      "Candle Light Dinner",
      "Couple Photoshoot",
      "Bed Decoration",
      "Toy Train Ride",
      "BBQ / Grill",
      "Lunch",
    ],
    Terms: [
      "Prices may vary during peak season and holidays",
      "30% advance payment required to confirm booking (*non-refundable)",
      "Final payment due before Check In",
      "Cancellation made less than 3 days before travel may attract 100% charge of the package cost",
      "Custom requests subject to availability",
      "Itinerary changes may affect pricing",
      "Special requests (e.g. dietary, accessibility) must be communicated in advance",
      "Bookings subject to terms of service",
      "Travel insurance recommended",
      "OotyGo not liable for unforeseen circumstances (e.g. weather, strikes)",
      "All bookings subject to availability at time of payment",
      "Prices and inclusions/exclusions subject to change without notice",
      "OotyGo reserves the right to refuse service to anyone",
      "By booking, you agree to OotyGo's full terms and conditions",
      "Travelers must comply with local laws and regulations",
      "OotyGo is not responsible for personal belongings",
      "Health and safety protocols must be followed",
      "Travelers are responsible for their own travel documents (e.g. ID, permits)",
      "OotyGo reserves the right to modify or cancel bookings in case of emergencies",
      "All disputes subject to jurisdiction of Nilgiris courts",
      "OotyGo is committed to sustainable and responsible tourism",
      "By booking, you agree to respect local culture and environment",
      "OotyGo may use photos/videos taken during the trip for promotional purposes unless otherwise requested",
      "For any queries or special requests, please contact us at least 7 days before travel",
      "OotyGo's decision is final in case of any disputes or issues",
      "Additional terms may apply based on specific selections or requests",
    ],
  },
  {
    type: "Family & Friends (PP)",
    image:
      "https://th.bing.com/th/id/R.9c748b6e2f448a1897d4cfbf08cafa31?rik=RdCOpb8hgahSbw&riu=http%3a%2f%2ftravel.home.sndimg.com%2fcontent%2fdam%2fimages%2ftravel%2ffullset%2f2015%2f08%2f21%2ffamily-road-trip-lake-okareka-new-zealand.jpg.rend.hgtvcom.1280.960.jpeg&ehk=elaJpqan3vVfrt3vWldhleP%2bNffsEJsJq2Xn0WCp6dA%3d&risl=&pid=ImgRaw&r=0",
    prices: {
      "2D 1N": { original: "₹2,999", discounted: "₹2,499" },
      "3D 2N": { original: "₹4,499", discounted: "₹3,999" },
      "4D 3N": { original: "₹5,999", discounted: "₹4,999" },
    },
    inclusions: [
      "Private cab",
      "Ooty Pickup & Drop",
      "Other location pickup available on request (Extra charges may apply)",
      "Hill view stay CI: 12pm CO: 10am",
      "Breakfast & Dinner",
      "Sightseeing",
      "Campfire",
    ],
    exclusions: ["Lunch", "Entry tickets", "Personal expenses"],
    addons: ["Toy Train Ride", "BBQ / Grill", "Lunch"],
    Terms: [
      "Prices are per person for a minimum of 10 to 14 people",
      "Prices may vary during peak season and holidays",
      "30% advance payment required to confirm booking (*non-refundable)",
      "Final payment due before Check In",
      "Cancellation made less than 3 days before travel may attract 100% charge of the package cost",
      "Custom requests subject to availability",
      "Itinerary changes may affect pricing",
      "Special requests (e.g. dietary, accessibility) must be communicated in advance",
      "Bookings subject to terms of service",
      "Travel insurance recommended",
      "OotyGo not liable for unforeseen circumstances (e.g. weather, strikes)",
      "All bookings subject to availability at time of payment",
      "Prices and inclusions/exclusions subject to change without notice",
      "OotyGo reserves the right to refuse service to anyone",
      "By booking, you agree to OotyGo's full terms and conditions",
      "Travelers must comply with local laws and regulations",
      "OotyGo is not responsible for personal belongings",
      "Health and safety protocols must be followed",
      "Travelers are responsible for their own travel documents (e.g. ID, permits)",
      "OotyGo reserves the right to modify or cancel bookings in case of emergencies",
      "All disputes subject to jurisdiction of Nilgiris courts",
      "OotyGo is committed to sustainable and responsible tourism",
      "By booking, you agree to respect local culture and environment",
      "OotyGo may use photos/videos taken during the trip for promotional purposes unless otherwise requested",
      "For any queries or special requests, please contact us at least 7 days before travel",
      "OotyGo's decision is final in case of any disputes or issues",
      "Additional terms may apply based on specific selections or requests",
    ],
  },
  {
    type: "Customizable",
    image:
      "https://www.pixelstalk.net/wp-content/uploads/images6/4K-Travel-Wallpaper-HD-Free-download.jpg",
    prices: {
      "2D 1N": { original: "₹3,499", discounted: "₹2,999" },
      "3D 2N": { original: "₹5,499", discounted: "₹4,499" },
      "4D 3N": { original: "₹6,999", discounted: "₹5,999" },
    },
    inclusions: [
      "Flexible itinerary",
      "Choice of cab type",
      "Stay options: Hill view / Heritage / Budget / Villa / Tent / Cottage / Bungalow / Resort",
      "Meal plan: Breakfast only / All meals",
      "Sightseeing as per preference",
      "Optional Campfire / BBQ",
    ],
    exclusions: ["Entry tickets", "Personal expenses", "Unselected addons"],
    addons: [
      "Toy Train Ride",
      "BBQ / Grill",
      "Candle Light Dinner",
      "Photoshoot",
      "Adventure activities",
      "Lunch",
    ],
    Terms: [
      "Prices vary based on selections",
      "Minimum 2 travelers required",
      "Customizations must be finalized 7 days before travel",
      "Prices may vary during peak season and holidays",
      "30% advance payment required to confirm booking (*non-refundable)",
      "Final payment due before Check In",
      "Cancellation made less than 3 days before travel may attract 100% charge of the package cost",
      "Custom requests subject to availability",
      "Itinerary changes may affect pricing",
      "Special requests (e.g. dietary, accessibility) must be communicated in advance",
      "Bookings subject to terms of service",
      "Travel insurance recommended",
      "OotyGo not liable for unforeseen circumstances (e.g. weather, strikes)",
      "All bookings subject to availability at time of payment",
      "Prices and inclusions/exclusions subject to change without notice",
      "OotyGo reserves the right to refuse service to anyone",
      "By booking, you agree to OotyGo's full terms and conditions",
      "Travelers must comply with local laws and regulations",
      "OotyGo is not responsible for personal belongings",
      "Health and safety protocols must be followed",
      "Travelers are responsible for their own travel documents (e.g. ID, permits)",
      "OotyGo reserves the right to modify or cancel bookings in case of emergencies",
      "All disputes subject to jurisdiction of Nilgiris courts",
      "OotyGo is committed to sustainable and responsible tourism",
      "By booking, you agree to respect local culture and environment",
      "OotyGo may use photos/videos taken during the trip for promotional purposes unless otherwise requested",
      "For any queries or special requests, please contact us at least 7 days before travel",
      "OotyGo's decision is final in case of any disputes or issues",
      "Additional terms may apply based on specific selections or requests",
    ],
  },
];

const Contant = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => {
    setVisible(window.scrollY > 100);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll-reveal: stagger elements into view as the user scrolls (rect-based)
  useEffect(() => {
    document.body.classList.add("js-reveal");
    const selector = [
      ".ooty-card", ".how-card", ".Cab-Card", ".stay-card", ".review-card",
      ".Collab-Card", ".Testimonial-Card", ".WhyOotyGo-Card", ".Sightseeing-Card",
      ".gallery-item", ".about-hl", ".faq-item", ".stat-item", ".about-media", ".about-copy",
    ].join(",");
    let els = [];

    const bind = () => {
      els = Array.prototype.slice.call(document.querySelectorAll(selector));
      els.forEach((el) => {
        if (el.dataset.revBound) return;
        el.dataset.revBound = "1";
        const sibs = Array.prototype.indexOf.call(el.parentElement?.children || [], el);
        el.style.transitionDelay = `${Math.min(sibs, 6) * 80}ms`;
      });
    };
    const reveal = () => {
      const vh = window.innerHeight;
      els.forEach((el) => {
        if (el.classList.contains("in")) return;
        const r = el.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) el.classList.add("in");
      });
    };

    bind(); reveal();
    const onScroll = () => window.requestAnimationFrame(reveal);
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    // re-scan for async-rendered nodes (e.g. live Google reviews)
    const t1 = setTimeout(() => { bind(); reveal(); }, 700);
    const t2 = setTimeout(() => { bind(); reveal(); }, 2200);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      clearTimeout(t1); clearTimeout(t2);
      document.body.classList.remove("js-reveal");
    };
  }, []);

  const [selectedDurations, setSelectedDurations] = useState(
    packages.map(() => "2D 1N"),
  );

  const handleDurationChange = (pkgIndex, duration) => {
    const updated = [...selectedDurations];
    updated[pkgIndex] = duration;
    setSelectedDurations(updated);
  };

  const partners = [
    {
      title: "🏡 Property Owners",
      description:
        "List your cottages, homestays, and tent stays with OotyGo to reach verified travelers and boost seasonal bookings.",
      benefits: ["Free listing support", "Verified leads", "Heritage branding"],
    },
    {
      title: "🚕 Cab Operators",
      description:
        "Partner with OotyGo to receive daily cab bookings for sightseeing, transfers, and outstation trips.",
      benefits: [
        "Transparent pricing",
        "WhatsApp leads",
        "Flexible scheduling",
      ],
    },
    {
      title: "📱 Social Media Influencers",
      description:
        "Collaborate with OotyGo to promote local travel, eco-tourism, and heritage stays. Let’s grow together.",
      benefits: ["Brand features", "Sponsored stays", "Cross-promotion"],
    },
  ];

  const testimonials = [
    {
      name: "Priya R.",
      role: "Couple Traveler from Chennai",
      feedback:
        "OotyGo made our honeymoon unforgettable! The cab was punctual, the cottage was cozy, and the sightseeing was magical. Highly recommended!",
    },
    {
      name: "Arun S.",
      role: "Group Leader from Bangalore",
      feedback:
        "We booked a group tour with OotyGo and everything was smooth—from cab coordination to local guides. Great support and transparent pricing!",
    },
    {
      name: "Kannan",
      role: "Influencer @Pulipmittai",
      feedback:
        "Collaborating with OotyGo was a delight. Their team is professional, and the heritage branding matched my audience perfectly. Looking forward to more!",
    },
    {
      name: "Ravi T.",
      role: "Family Trip Organizer",
      feedback:
        "Our family trip to Coonoor and Pykara was seamless. OotyGo’s team handled everything with care. The kids loved the lake and safari!",
    },
  ];

  const reasons = [
    {
      title: "✅ Trusted Local Expertise",
      description:
        "Born in the Nilgiris, we know every trail, tea estate, and hidden gem. Our team blends tech with tradition to give you authentic experiences.",
    },
    {
      title: "🚗 Seamless Cab & Stay Booking",
      description:
        "From sightseeing cabs to heritage cottages, OotyGo offers transparent pricing, verified partners, and instant WhatsApp support.",
    },
    {
      title: "🌿 Heritage-Inspired Branding",
      description:
        "We celebrate Tamil culture, eco-tourism, and local livelihoods. Every trip supports community growth and sustainable travel.",
    },
    {
      title: "📱 Smart, Bilingual Support",
      description:
        "English or Tamil, we’ve got you covered. Our team responds fast via WhatsApp, email, and phone — no bots, just real people.",
    },
    {
      title: "🤝 Collaboration-Driven Growth",
      description:
        "We partner with property owners, cab operators, and influencers to create win-win bookings and long-term trust.",
    },
  ];

  const [openTermsIndex, setOpenTermsIndex] = useState(null);
  const [bookingModal, setBookingModal] = useState(null); // null = closed, string = packageInfo

  // Live pricing from the CRM (auto-syncs packages/rooms/vehicles + peak mode)
  const [pricing, setPricing] = useState(null);
  useEffect(() => {
    const loadPricing = () =>
      fetch(PRICING_API).then((r) => r.json()).then((d) => setPricing(d)).catch(() => {});
    loadPricing();

    // Instant updates: when staff edit prices or flip peak mode in the CRM,
    // the backend broadcasts a 'pricing.update' over WebSocket → refetch live.
    connectRealtime();
    const off = onRealtime((evt) => {
      if (evt.type === "pricing.update") loadPricing();
    });
    return () => { off(); closeRealtime(); };
  }, []);
  const livePackages = pricing?.packages?.length ? pricing.packages : null;
  const liveVehicles = pricing?.vehicles?.length ? pricing.vehicles : null;
  const liveRooms = pricing?.rooms?.length ? pricing.rooms : null;

  return (
    <>
      <Navbar />
      <Hero />
      <AboutIntro />
      {/* Partner ads — placed right below "About OotyGo" */}
      <HomeAds />
      <StatsBand />
      <div className="ooty-packages-container" id="packages">
        <span className="section-eyebrow">Tailored Getaways</span>
        <h2 className="ooty-title">Ooty Tour Packages</h2>
        <p className="ooty-subtitle">Pick a vibe, choose your nights, and we handle the rest — stays, cabs, sightseeing &amp; more.</p>
        <OfferCountdown />

        {livePackages ? (
          <LivePackages
            packages={livePackages}
            peakActive={pricing.peakActive}
            peakLabel={pricing.peakLabel}
            onBook={setBookingModal}
          />
        ) : (
        <div className="ooty-card-grid">
          {packages.map((pkg, index) => {
            const selectedDuration = selectedDurations[index];
            const price = pkg.prices[selectedDuration];
            const isDiscounted = typeof price === "object";

            return (
              <div className="ooty-card" key={index}>
                <img src={pkg.image} alt={pkg.type} className="ooty-image" />
                <div className="ooty-card-content">
                  <h3>{pkg.type}</h3>

                  <p className="ooty-price">
                    {isDiscounted ? (
                      <>
                        <span
                          style={{
                            textDecoration: "line-through",
                            color: "#888",
                            marginRight: "8px",
                          }}
                        >
                          {price.original}
                        </span>
                        <span
                          style={{ color: "#ff0000ff", fontWeight: "bold" }}
                        >
                          {price.discounted}
                        </span>
                      </>
                    ) : (
                      <span style={{ color: "#2E8B57", fontWeight: "bold" }}>
                        {price}
                      </span>
                    )}
                  </p>

                  <div className="ooty-duration-select">
                    {Object.keys(pkg.prices).map((duration) => (
                      <button
                        key={duration}
                        className={`ooty-duration-btn ${
                          selectedDuration === duration ? "active" : ""
                        }`}
                        onClick={() => handleDurationChange(index, duration)}
                      >
                        {duration}
                      </button>
                    ))}
                  </div>

                  <div className="ooty-details">
                    <div>
                      <strong>✅ Inclusions:</strong>
                      <ul>
                        {pkg.inclusions.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <strong>❌ Exclusions:</strong>
                      <ul>
                        {pkg.exclusions.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="ooty-addons">
                    <strong>🎁 Add-ons: (Separate)</strong>
                    <ul>
                      {pkg.addons.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>

                  {pkg.Terms && (
                    <button
                      className="ooty-button secondary"
                      onClick={() => setOpenTermsIndex(index)}
                    >
                      📜 View Terms
                    </button>
                  )}

                  <button
                    className="ooty-button"
                    onClick={() =>
                      setBookingModal(
                        `${pkg.type} – ${selectedDuration} (${isDiscounted ? price.discounted : price} per person)`
                      )
                    }
                  >
                    Book Now
                  </button>
                </div>
              </div>
            );
          })}
        </div>
        )}

        {/* ✅ Modal rendered outside the card grid */}
        {openTermsIndex !== null && (
          <TermsModal
            terms={packages[openTermsIndex].Terms}
            onClose={() => setOpenTermsIndex(null)}
          />
        )}
      </div>
      {/* ===== full-bleed sections below ===== */}

      <HowItWorks />
      <Sightseeing />
      <Gallery />
      {liveRooms ? (
        <LiveRooms rooms={liveRooms} peakActive={pricing.peakActive} peakLabel={pricing.peakLabel} onBook={setBookingModal} />
      ) : (
        <FeaturedStays />
      )}

      {/* Cab Details */}

        <div className="Cab-Booking" id="cab">
          <h2 className="Cab-Title">🚗 Ooty Cab Booking</h2>
          {liveVehicles ? (
            <LiveVehicles vehicles={liveVehicles} peakActive={pricing.peakActive} peakLabel={pricing.peakLabel} onBook={setBookingModal} />
          ) : (
          <div className="Cab-Contant">
            <div className="Cab-Card">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  fill="currentColor"
                  class="bi bi-taxi-front-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M6 1a1 1 0 0 0-1 1v1h-.181A2.5 2.5 0 0 0 2.52 4.515l-.792 1.848a.8.8 0 0 1-.38.404c-.5.25-.855.715-.965 1.262L.05 9.708a2.5 2.5 0 0 0-.049.49v.413c0 .814.39 1.543 1 1.997V14.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1.338c1.292.048 2.745.088 4 .088s2.708-.04 4-.088V14.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1.892c.61-.454 1-1.183 1-1.997v-.413q0-.248-.049-.49l-.335-1.68a1.8 1.8 0 0 0-.964-1.261.8.8 0 0 1-.381-.404l-.792-1.848A2.5 2.5 0 0 0 11.181 3H11V2a1 1 0 0 0-1-1zM4.309 4h7.382a.5.5 0 0 1 .447.276l.956 1.913a.51.51 0 0 1-.497.731c-.91-.073-3.35-.17-4.597-.17s-3.688.097-4.597.17a.51.51 0 0 1-.497-.731l.956-1.913A.5.5 0 0 1 4.309 4M4 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0m10 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-9 0a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1" />
                </svg>
              </span>
              <h3>4 + 1 Seator 9 Am to 6 pm</h3>
              <p>
                <strike>₹2,999</strike> ₹2,499 onwards
              </p>
              <ul>
                <li>7 to 10 Places</li>
                <li>Extra hour: ₹150</li>
                <li>Extra km: ₹20</li>
              </ul>
              <button
                className="Cab-Button"
                onClick={() => setBookingModal("Cab – 4+1 Seater Sightseeing 9AM–6PM (₹2,499)")}
              >
                Book Now
              </button>
            </div>
            <div className="Cab-Card">
              <span>
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 640 512"
                  height="40"
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"></path>
                </svg>
              </span>
              <h3>7 + 1 Seator 9 Am to 6 Pm</h3>
              <p>
                <strike>₹5,999</strike> ₹4,499 onwards
              </p>
              <ul>
                <li>5 to 7 Places</li>
                <li>Extra hour: ₹500</li>
                <li>Extra km: ₹50</li>
              </ul>
              <button
                className="Cab-Button"
                onClick={() => setBookingModal("Cab – 7+1 Seater Sightseeing 9AM–6PM (₹4,499)")}
              >
                Book Now
              </button>
            </div>
            <div className="Cab-Card">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  fill="currentColor"
                  class="bi bi-bus-front"
                  viewBox="0 0 16 16"
                >
                  <path d="M5 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0m8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-6-1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm1-6c-1.876 0-3.426.109-4.552.226A.5.5 0 0 0 3 4.723v3.554a.5.5 0 0 0 .448.497C4.574 8.891 6.124 9 8 9s3.426-.109 4.552-.226A.5.5 0 0 0 13 8.277V4.723a.5.5 0 0 0-.448-.497A44 44 0 0 0 8 4m0-1c-1.837 0-3.353.107-4.448.22a.5.5 0 1 1-.104-.994A44 44 0 0 1 8 2c1.876 0 3.426.109 4.552.226a.5.5 0 1 1-.104.994A43 43 0 0 0 8 3" />
                  <path d="M15 8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1V2.64c0-1.188-.845-2.232-2.064-2.372A44 44 0 0 0 8 0C5.9 0 4.208.136 3.064.268 1.845.408 1 1.452 1 2.64V4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v3.5c0 .818.393 1.544 1 2v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V14h6v1.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2c.607-.456 1-1.182 1-2zM8 1c2.056 0 3.71.134 4.822.261.676.078 1.178.66 1.178 1.379v8.86a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 11.5V2.64c0-.72.502-1.301 1.178-1.379A43 43 0 0 1 8 1" />
                </svg>
              </span>
              <h3>13 + 1 Seator 9 Am to 6 Pm</h3>
              <p>
                <strike>₹6,999</strike> ₹5,499 onwards
              </p>
              <ul>
                <li>5 to 7 Places</li>
                <li>Extra hour: ₹700</li>
                <li>Extra km: ₹80</li>
                <li>Parking / Tolls extra</li>
              </ul>
              <button
                className="Cab-Button"
                onClick={() => setBookingModal("Cab – 13+1 Seater Sightseeing 9AM–6PM (₹5,499)")}
              >
                Book Now
              </button>
            </div>
            <div className="Cab-Card">
              <span>
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 576 512"
                  height="40"
                  width="40px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M288 0C422.4 0 512 35.2 512 80l0 16 0 32c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-192 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32c0 0 0 0 0 0l0-32s0 0 0 0l0-16C64 35.2 153.6 0 288 0zM128 160l0 96c0 17.7 14.3 32 32 32l112 0 0-160-112 0c-17.7 0-32 14.3-32 32zM304 288l112 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-112 0 0 160zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 80c0-8.8-7.2-16-16-16L208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16z"></path>
                </svg>
              </span>
              <h3>22 + 1 Seator 9 Am to 6 Pm</h3>
              <p>
                <strike>₹7,499</strike> ₹6,499 onwards
              </p>
              <ul>
                <li>5 to 7 Places</li>
                <li>Extra hour: ₹900</li>
                <li>Extra km: ₹90</li>
                <li>Parking / Tolls extra</li>
              </ul>
              <button
                className="Cab-Button"
                onClick={() => setBookingModal("Cab – 22+1 Seater Sightseeing 9AM–6PM (₹6,499)")}
              >
                Book Now
              </button>
            </div>
            <div className="Cab-Card">
              <span>
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 24 24"
                  height="40"
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M8.36547 10L11.2 8H14.6915L13.5996 5H11V3H15L16.0919 6H20V9H17.1838L18.6405 13.0022C21.0608 13.0764 23 15.0617 23 17.5C23 19.9853 20.9853 22 18.5 22C16.0147 22 14 19.9853 14 17.5C14 15.6722 15.0897 14.0989 16.6549 13.3944L15.4194 10H14.4718L12.89 15.87L9.96536 16.9389C9.98822 17.1227 10 17.31 10 17.5C10 19.9853 7.98528 22 5.5 22C3.01472 22 1 19.9853 1 17.5C1 15.5407 2.25221 13.8738 4 13.2561V12H2V10H8.36547ZM5.5 20C6.88071 20 8 18.8807 8 17.5C8 16.1193 6.88071 15 5.5 15C4.11929 15 3 16.1193 3 17.5C3 18.8807 4.11929 20 5.5 20ZM18.5 20C19.8807 20 21 18.8807 21 17.5C21 16.1193 19.8807 15 18.5 15C17.1193 15 16 16.1193 16 17.5C16 18.8807 17.1193 20 18.5 20Z"></path>
                </svg>
              </span>
              <h3>Bike 9 Am to 6 Pm</h3>
              <h3>Temporarily Unavailable😕</h3>
              <p>
                <strike>₹999</strike> ₹499 onwards for rental
              </p>
              <ul>
                <li>Km: 50 Km per day</li>
                <li>Extra hour: ₹100</li>
                <li>Extra km: ₹10</li>
                <li>Valid Driving Licence</li>
                <li>Parking extra</li>
              </ul>
              <button
                className="Cab-Button"
                onClick={() => setBookingModal("Bike Rental 9AM–6PM (₹499)")}
              >
                Book Now
              </button>
            </div>
          </div>
          )}
        </div>

        {/* Colabarations */}

        <div className="Collab-Container" id="collaboration">
          <h2 className="Collab-Title">🤝 Partner with OotyGo</h2>
          <p className="Collab-Intro">
            We invite property owners, cab operators, and influencers to
            collaborate with OotyGo and grow your bookings, visibility, and
            impact.
          </p>
          <div className="Collab-Grid">
            {partners.map((partner, index) => (
              <div className="Collab-Card" key={index}>
                <h3>{partner.title}</h3>
                <p>{partner.description}</p>
                <ul>
                  {partner.benefits.map((item, i) => (
                    <li key={i}>✅ {item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="Collab-Contact">
            <h4>📞 Contact Admin</h4>
            <p>
              Phone 1:{" "}
              <a
                href="https://wa.me/919655062118"
                target="_blank"
                rel="noopener noreferrer"
              >
                +91 96550-62118 (WhatsApp)
              </a>
            </p>
            <p>
              Phone 2:{" "}
              <a
                href="https://wa.me/916374657778"
                target="_blank"
                rel="noopener noreferrer"
              >
                +91 63746-57778 (WhatsApp)
              </a>
            </p>
            <p>
              Email: <a href="mailto:info@ootygo.com">info@ootygo.com</a>
            </p>
          </div>
        </div>

        {/* Live Google reviews */}
        <ReviewsLive />

        {/* Testimonials */}
        <div className="Testimonial-Container" id="testimonials">
          <h2 className="Testimonial-Title">
            🌟 What Our Travelers Say{" "}
            <a
              href="https://search.google.com/local/writereview?placeid=ChIJ_TVOwof9YiAR4ok4ka68QcA"
              target="_blank"
              rel="noopener noreferrer"
              className="Review-Link"
            >
              <button
                style={{
                  padding: "10px 20px",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  fontSize: "16px",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  background: "linear-gradient(90deg, #ff8a00, #e52e71)",
                  cursor: "pointer",
                  marginLeft: "10px",
                  marginTop: "10px",
                }}
              >
                ⭐ Leave a Google Review
              </button>
            </a>
          </h2>

          <div className="Testimonial-Grid">
            {testimonials.map((review, index) => (
              <div className="Testimonial-Card" key={index}>
                <p className="Testimonial-Feedback">“{review.feedback}”</p>
                <h4 className="Testimonial-Name">— {review.name}</h4>
                <p className="Testimonial-Role">{review.role}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="WhyOotyGo-Container">
          <h2 className="WhyOotyGo-Title">💡 Why Choose OotyGo?</h2>
          <div className="WhyOotyGo-Grid">
            {reasons.map((reason, index) => (
              <div className="WhyOotyGo-Card" key={index}>
                <h3>{reason.title}</h3>
                <p>{reason.description}</p>
              </div>
            ))}
          </div>
        </div>

        <FAQ />
        <CtaBand />

        {/* Payment */}
        <Payment />

      {/* Lead capture modal */}
      {bookingModal !== null && (
        <BookingLeadModal
          packageInfo={bookingModal}
          onClose={() => setBookingModal(null)}
        />
      )}
      {visible && (
        <button
          className="scroll-to-top"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="white"
            viewBox="0 0 24 24"
            className="scroll-to-top-icon"
          >
            <path d="M12 4l-8 8h6v8h4v-8h6z" />
          </svg>
        </button>
      )}
    </>
  );
};

export default Contant;
